module.exports = __webpack_public_path__ + "static/media/1.dcda7489.jpg";